import React, { useEffect, useState, useRef } from "react";
import { Form } from "react-bootstrap";
import { AgGridReact } from '@ag-grid-community/react';
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { LicenseManager } from "@ag-grid-enterprise/core";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-balham.css";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import "../MainBox.css";
import "./USBox.css";
import { apiHelper } from "../../lib/ApiHelper";
import PRHError from "../../lib/PRHError";
import PRHLoader from "../../lib/PRHLoader";
import { param } from "jquery";
// Register ag-Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule, ExcelExportModule]);

// Set ag-Grid Enterprise license key
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-058820}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Penguin_Random_House_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{InventoryHub}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{InventoryHub}_need_to_be_licensed___{InventoryHub}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_April_2025}____[v3]_[01]_MTc0MzcyMTIwMDAwMA==a87b1efc2ee2da35884b94c846d80314");

/*
PSEUDOCODE / PLAN (detailed)
- Goal: Correct the Set filter for the 'ss' column so the filter options do not include 'OS' and 'OP' by default.
- Approach:
  1. Use the correct ag-Grid API for Set filter values: `filterParams.values`.
  2. Implement `values` as a function that:
     - Iterates all nodes via `params.api.forEachNode`.
     - Collects unique `ss` values into a Set.
     - Normalizes values to strings and trims.
     - Excludes values whose uppercase form equals 'OS' or 'OP'.
     - Returns the filtered array or calls `params.successCallback(filteredArray)` if that callback exists.
  3. Apply the same `filterParams` to both `columnDefs` and `authorColumnDefs` SS columns.
  4. Keep other filter settings untouched.
- Implementation details:
  - Use `Set` to gather unique values.
  - Defensive checks for null/undefined/empty values.
  - Ensure compatibility across ag-Grid versions by supporting both return and callback styles.
*/

export default function Series(props) {
    const [seriesInfo, setSeriesInfo] = useState({ Series: "", SeriesName: "" });
    const [rowData, setRowData] = useState([]);
    const [otherWorkData, setOtherWorkData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedISBN, setSelectedISBN] = useState([]);
    const [selectedISBNAuth, setSelectedISBNAuth] = useState([]);
    const [totalISBN, setTotalISBN] = useState([]);
    const gridRef = useRef(null);
    const otherGridRef = useRef(null);
    const gridAPIAuthor = useRef(null);
    const [heightSeriesGrid, setHeightSeriesGrid] = useState(100);
    const [heightAuthorGrid,setHeightAuthorGrid] = useState(100);
    // Generic selection handler that works with any grid API
    const handleSelectionChanged = (gridApi) => {
        if (!gridApi) return;

        // Detect which grid triggered the event
        const whichGrid = gridApi === gridRef.current?.api
            ? "SeriesGrid"
            : gridApi === otherGridRef.current?.api
                ? "OtherWorksGrid"
                : "UnknownGrid";


        const selectedRows = gridApi.getSelectedRows();
        const modifiedData = selectedRows.map(i => i.isbn);

        // Keep selections exclusive between grids
        if (whichGrid === "SeriesGrid") {
            setSelectedISBN(modifiedData);
            //  otherGridRef.current?.api?.deselectAll();

        } else if (whichGrid === "OtherWorksGrid") {
            setSelectedISBNAuth(modifiedData);
            //    gridRef.current?.api?.deselectAll();

        }

      //  setSelectedISBN(modifiedData);
        const existingISBNs = (props?.isbnData?.listISBN || []).map(item => item.isbn);
        const modifiedSet = new Set(modifiedData);
        const filteredExisting = existingISBNs.filter(isbn => !modifiedSet.has(isbn));
        const totalList = [...modifiedData, ...filteredExisting];
        setTotalISBN(totalList);
    };
    const [gridOptions, setgridOption] = useState({
        defaultColDef: {
            resizable: true,
            sortable: true,
            filter: true,
        },
        animateRows: true,
        rowSelection: 'multiple',
        accentedSort: true,
        suppressDragLeaveHidesColumns: true,
        suppressColumnMoveAnimation: false,
        suppressRowClickSelection: true,
        onSelectionChanged: (params) => handleSelectionChanged(params.api),
    });
    const onGridReady = (params) => {
        gridAPIAuthor.current = params.api;

        // Wait briefly to ensure data is rendered
        setTimeout(() => {
            
            // Apply filter model
            params.api.setFilterModel({
                ss: {
                    filterType: "text",
                    operator: "AND",
                    condition1: {
                        type: "notContains",
                        filter: "OP",
                    },
                    condition2: {
                        type: "notContains",
                        filter: "OS",
                    },
                },
            });

            // Trigger filter
            params.api.onFilterChanged();
        }, 100); // small delay ensures data is loaded
    };

    function formatNumberWithCommas(number) {
        if (isNaN(number) || !number) {
            return '';
        }
        let str = number.toString();
        let parts = str.split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (parts[1] && parts[1].length === 1) {
            parts[1] += "0";
        }
        return parts.join(".");
    }

    const showFormatDate = (dateString) => {
        if (dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const formattedDate = `${month}/${day}/${year}`;
            return formattedDate;
        }
        return null;
    };

    // Export function now accepts an optional grid ref (default to primary gridRef)
    const onExportClick = (gridRefParam = gridRef) => {
        const api = gridRefParam?.current?.api;
        if (!api) {
            alert("Grid API is not ready.");
            return;
        }

        if (!api.exportDataAsExcel) {
            alert("Excel export is not available. Please ensure the ag-Grid Enterprise Excel export module is imported and licensed.");
            return;
        }

        api.exportDataAsExcel({
            fileName: "series-data.xlsx",
            allColumns: true,
            processCellCallback: (params) => {
                const colId = params.column.getColId();

                // Force ISBN to be text using apostrophe
                if (colId === "isbn") {
                    return `'${params.value}`;
                }
                const dateFields = ["osd", "nextWIPDate", "lastRptDate"];
                if (dateFields.includes(colId) && params.value instanceof Date) {
                    const date = params.value;
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const year = date.getFullYear();
                    return `${month}/${day}/${year}`;
                }
                return params.value;
            }
        });
    };

    useEffect(() => {
        const fetchSeries = async () => {
            setSeriesInfo({ Series: "", SeriesName: "" });
            setRowData([]);
            setLoading(true);
            const isbnId = props?.ISBNId;
            if (props?.metaData && isbnId && isbnId !== "") {
                const resulttemp = await apiHelper.inventoryPostCall("getseries", { value: isbnId });
                if (resulttemp) {
                    const { seriesValue, otherWork } = resulttemp;
                    if (seriesValue && seriesValue.seriesInfo && seriesValue.seriesData) {
                        setSeriesInfo({
                            Series: seriesValue.seriesInfo.series ?? "",
                            SeriesName: seriesValue.seriesInfo.seriesName ?? ""
                        });
                        setRowData(seriesValue.seriesData);
                        setHeightSeriesGrid(Math.min(27 * (seriesValue.seriesData.length + 2),433) );
                    } else {
                        setSeriesInfo({ Series: "", SeriesName: "" });
                        setRowData([]);
                    }
                    // --- Handle OtherWork (new dataset) ---
                    if (otherWork?.seriesData && otherWork.seriesData.length > 0) {
                        setOtherWorkData(otherWork.seriesData);
                        setHeightAuthorGrid(Math.min(27 * (otherWork.seriesData.length + 2), 433));
                    } else {
                        setOtherWorkData([]);
                    }
                } else {
                    setSeriesInfo({ Series: "", SeriesName: "" });
                    setRowData([]);
                }
            }
            setLoading(false);
        };
        fetchSeries();
        setSelectedISBN([]);
        setSelectedISBNAuth([]);
        setTotalISBN([]);
    }, [props.metaData]);

    const selectISBNClick = async () => {
        const prepend = false;
        const formOverview = true; // extra check for duplicates
        const updateSetTitle = true;
        if (!totalISBN || totalISBN.length === 0) {
            if (gridRef?.current?.api) gridRef.current.api.deselectAll();
            if (otherGridRef?.current?.api) otherGridRef.current.api.deselectAll();
            return;
        }
        await apiHelper.ISBNCheck(totalISBN, props.upn, props.setIsbnData, props.isbnData, prepend, formOverview, updateSetTitle);
    };

    // Use a stable handler to avoid multiple calls
    const handleClicked = (isbn) => (event) => {
        event.stopPropagation();
        if (isbn) {
            window.open(`/overview?isbns=${isbn}`, '_blank');
        }
    };

/*    // Helper to provide filtered set filter values excluding OS/OP
    const ssFilterValuesProvider = (params) => {
        const values = new Set();

        params.api.forEachNode((node) => {
            const v = node?.data?.ss;
            if (v !== null && v !== undefined && v !== "") {
                values.add(String(v).trim());
            }
        });

        // Define exclusion list in uppercase for consistency
        const exclude = new Set(["OS","IP", "OP"]);

        // Filter out unwanted values
        const out = [...values].filter(
            (v) => !exclude.has(v.trim().toUpperCase())
        );

        // ✅ Correct callback for Ag Grid
        params.success(out);
    };
*/

    // Shared SS filterParams function used below
    const ssFilterParams = {
       /* values: (params) => {
            const all = new Set();
            params.api.forEachNode((node) => {
                const v = node?.data?.ss;
                if (v !== null && v !== undefined && v !== "") {
                    all.add(String(v).trim());
                }
            });
            const exclude = new Set(["OS", "OP"]); // values to exclude from default options
            const result = Array.from(all).filter(v => !exclude.has(v.toUpperCase()));

            // Support both callback-style and return-style for different ag-Grid versions
            if (typeof params.successCallback === "function") {
                params.successCallback(result);
            } else {
                return result;
            }
        },
        suppressMiniFilter: false,*/
       
    };

    const columnDefs = [{ headerName: '', width: 40, checkboxSelection: true, headerCheckboxSelection: true, multipleSelection: true, suppressMenu: true, headerClass: "HeaderClassSource1", cellClass: "checkboxcell" },
        {
            headerName: "ISBN", field: "isbn", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left cursor-pointer link-isbn", width: 100, cellRenderer: (params) => {
                return <span onClick={handleClicked(params.value)}>{params.value}</span>;
            }, filter: "agSetColumnFilter"
        },
        { headerName: "Title", field: "title", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 200 },

        {
            headerName: "OSD", field: "osd", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
            filter: "agDateColumnFilter",
            valueGetter: (params) => {
                if (!params.data.osd || params.data.osd === "0001-01-01T00:00:00") return null;
                return new Date(params.data.osd); // Return actual Date object for filtering
            },
            valueFormatter: (params) => {
                return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
            },

            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1; // Handle empty cases
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder; // Default behavior
                    }
                }
            },
            sort: 'desc',
            width: 80,
        },
        { headerName: "Fmt", field: "fmt", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70 },
        {
            headerName: "SS",
            field: "ss",
            resizable: true,
            sortable: true,
            filter: "agSetColumnFilter",
            headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left",
            width: 70,
        },
        { headerName: "Series #", field: "seriesNumber", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 90, filter: "agNumberColumnFilter" },
        { headerName: "Div", field: "div", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 70, filter: "agNumberColumnFilter" },
        { headerName: "Imprint Name", field: "imprintName", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 200, filter: "agSetColumnFilter" },
        { headerName: "Active Batch", field: "activeBatch", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 120, filter: "agSetColumnFilter" },
        {
            headerName: "Gross Inv", field: "grossInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Net Bulk Inv", field: "netBulkInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 120, filter: "agNumberColumnFilter"
        },

        {
            headerName: "Ttl WIP", field: "totalWIP", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Next WIP Dte", field: "nextWIPDate", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
            filter: "agDateColumnFilter",
            valueGetter: (params) => {
                if (!params.data.nextWIPDate || params.data.nextWIPDate === "0001-01-01T00:00:00") return null;
                return new Date(params.data.nextWIPDate); // Return actual Date object for filtering
            },
            valueFormatter: (params) => {
                return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
            },

            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1; // Handle empty cases
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder; // Default behavior
                    }
                }
            },
            width: 130
        },
        {
            headerName: "Last Rpt Qty", field: "lastRptQty", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, width: 120, filter: "agNumberColumnFilter"
        },
        {
            headerName: "Last Rpt Date", field: "lastRptDate", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", valueGetter: (params) => {
                if (!params.data.lastRptDate || params.data.lastRptDate === "0001-01-01T00:00:00") return null;
                return new Date(params.data.lastRptDate); // Return actual Date object for filtering
            },
            filter: "agDateColumnFilter",
            valueFormatter: (params) => {
                return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
            },
            filterParams: {
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1; // Handle empty cases
                    const cellDate = new Date(cellValue);
                    return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
                }, filterPlaceholder: (params) => {
                    switch (params.filterOptionKey) {
                        case "greaterThanOrEqual":
                            return "Enter start date...";
                        case "lessThanOrEqual":
                            return "Enter end date...";
                        case "inRange":
                            return "Select range...";
                        default:
                            return params.placeholder; // Default behavior
                    }
                }
            },
            width: 130
        },
        { headerName: "Print #", field: "printNum", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 100, filter: "agSetColumnFilter" },
        { headerName: "Title Block", field: "titleBlock", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 180, filter: "agSetColumnFilter" },
        { headerName: "GLB Flag", field: "glbFlag", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-centre", width: 100 },
        { headerName: "Series Name", valueGetter: () => seriesInfo.SeriesName, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150, filter: "agSetColumnFilter" },
        {
            headerName: "Prev 12mos Billings", field: "prev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 140, filter: "agNumberColumnFilter"
        },
        {
            headerName: "2nd Prev 12mos Billings", field: "secondPrev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 165, filter: "agNumberColumnFilter"
        },
        {
            headerName: "3rd Prev 12mos Billings", field: "thirdPrev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 160, filter: "agNumberColumnFilter"
        },
    ];



    const authorColumnDefs = [{ headerName: '', width: 40, checkboxSelection: true, headerCheckboxSelection: true, multipleSelection: true, suppressMenu: true, headerClass: "HeaderClassSource1", cellClass: "checkboxcell" },
    {
        headerName: "ISBN", field: "isbn", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left cursor-pointer link-isbn", width: 100, cellRenderer: (params) => {
            return <span onClick={handleClicked(params.value)}>{params.value}</span>;
        }, filter: "agSetColumnFilter"
    },
    { headerName: "Title", field: "title", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 200 },

    {
        headerName: "OSD", field: "osd", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
        filter: "agDateColumnFilter",
        valueGetter: (params) => {
            if (!params.data.osd || params.data.osd === "0001-01-01T00:00:00") return null;
            return new Date(params.data.osd); // Return actual Date object for filtering
        },
        valueFormatter: (params) => {
            return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
        },

        filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) => {
                if (!cellValue) return -1; // Handle empty cases
                const cellDate = new Date(cellValue);
                return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
            }, filterPlaceholder: (params) => {
                switch (params.filterOptionKey) {
                    case "greaterThanOrEqual":
                        return "Enter start date...";
                    case "lessThanOrEqual":
                        return "Enter end date...";
                    case "inRange":
                        return "Select range...";
                    default:
                        return params.placeholder; // Default behavior
                }
            }
        },
        sort: 'desc',
        width: 80,
    },
        { headerName: "Fmt", field: "fmt", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 70 },

    {
        headerName: "SS",
        field: "ss",
        resizable: true,
        sortable: true,
        filter: "agSetColumnFilter",
        headerClass: "HeaderClassSource",
        cellClass: "CellClassSource cell-text-left",
        width: 70,
        filterParams: {
            suppressMiniFilter: false, // user can search inside filter
            defaultToNothing: false,   // show all other values initially
        },
    },
    { headerName: "Series #", field: "seriesNumber", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 90, filter: "agNumberColumnFilter" },
    { headerName: "Div", field: "div", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 70, filter: "agNumberColumnFilter" },
    { headerName: "Imprint Name", field: "imprintName", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 200, filter: "agSetColumnFilter" },
    { headerName: "Active Batch", field: "activeBatch", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 120, filter: "agSetColumnFilter" },
    {
        headerName: "Gross Inv", field: "grossInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
            return <span>{formatNumberWithCommas(params.value)}</span>;
        }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
    },
    {
        headerName: "Net Bulk Inv", field: "netBulkInv", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
            return <span>{formatNumberWithCommas(params.value)}</span>;
        }, cellClass: "CellClassSource cell-text-right", width: 120, filter: "agNumberColumnFilter"
    },

    {
        headerName: "Ttl WIP", field: "totalWIP", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellRenderer: (params) => {
            return <span>{formatNumberWithCommas(params.value)}</span>;
        }, cellClass: "CellClassSource cell-text-right", width: 100, filter: "agNumberColumnFilter"
    },
    {
        headerName: "Next WIP Dte", field: "nextWIPDate", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right",
        filter: "agDateColumnFilter",
        valueGetter: (params) => {
            if (!params.data.nextWIPDate || params.data.nextWIPDate === "0001-01-01T00:00:00") return null;
            return new Date(params.data.nextWIPDate); // Return actual Date object for filtering
        },
        valueFormatter: (params) => {
            return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
        },

        filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) => {
                if (!cellValue) return -1; // Handle empty cases
                const cellDate = new Date(cellValue);
                return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
            }, filterPlaceholder: (params) => {
                switch (params.filterOptionKey) {
                    case "greaterThanOrEqual":
                        return "Enter start date...";
                    case "lessThanOrEqual":
                        return "Enter end date...";
                    case "inRange":
                        return "Select range...";
                    default:
                        return params.placeholder; // Default behavior
                }
            }
        },
        width: 130
    },
    {
        headerName: "Last Rpt Qty", field: "lastRptQty", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", cellRenderer: (params) => {
            return <span>{formatNumberWithCommas(params.value)}</span>;
        }, width: 120, filter: "agNumberColumnFilter"
    },
    {
        headerName: "Last Rpt Date", field: "lastRptDate", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", valueGetter: (params) => {
            if (!params.data.lastRptDate || params.data.lastRptDate === "0001-01-01T00:00:00") return null;
            return new Date(params.data.lastRptDate); // Return actual Date object for filtering
        },
        filter: "agDateColumnFilter",
        valueFormatter: (params) => {
            return showFormatDate(params.value); // Display formatted date in MM/DD/YYYY
        },
        filterParams: {
            comparator: (filterLocalDateAtMidnight, cellValue) => {
                if (!cellValue) return -1; // Handle empty cases
                const cellDate = new Date(cellValue);
                return cellDate.setHours(0, 0, 0, 0) - filterLocalDateAtMidnight.getTime();
            }, filterPlaceholder: (params) => {
                switch (params.filterOptionKey) {
                    case "greaterThanOrEqual":
                        return "Enter start date...";
                    case "lessThanOrEqual":
                        return "Enter end date...";
                    case "inRange":
                        return "Select range...";
                    default:
                        return params.placeholder; // Default behavior
                }
            }
        },
        width: 130
    },
    { headerName: "Print #", field: "printNum", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 100, filter: "agSetColumnFilter" },
    { headerName: "Title Block", field: "titleBlock", resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 180, filter: "agSetColumnFilter" },
        { headerName: "GLB Flag", field: "glbFlag", resizable: true, sortable: true, filter: "agSetColumnFilter", headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-centre", width: 100 },

        { headerName: "Series Name", valueGetter: () => seriesInfo.SeriesName,  resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-left", width: 150, filter: "agSetColumnFilter" },
        {
            headerName: "Prev 12mos Billings", field: "prev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 140, filter: "agNumberColumnFilter"
        },
        {
            headerName: "2nd Prev 12mos Billings", field: "secondPrev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 165, filter: "agNumberColumnFilter"
        },
        {
            headerName: "3rd Prev 12mos Billings", field: "thirdPrev12mosBillings", cellRenderer: (params) => {
                return <span>{formatNumberWithCommas(params.value)}</span>;
            }, resizable: true, sortable: true, headerClass: "HeaderClassSource", cellClass: "CellClassSource cell-text-right", width: 160, filter: "agNumberColumnFilter"
        },
    ];


    return (
        <div className="accordion-content container-fluid specform">
            {loading && (
                <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                    <PRHLoader />
                </div>
            )}
            <Form noValidate="noValidate" style={{ marginLeft: "10px", marginTop: "10px" }}>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <Form.Group controlId="seriesId">
                                    <Form.Label>Series</Form.Label>
                                    <input
                                        className="custom-input left-p-input"
                                        type="text"
                                        value={seriesInfo.Series}
                                        disabled
                                        placeholder="Series"
                                        style={{ width: 120 }}
                                    />
                                </Form.Group>
                            </td>
                            <td className="pl-4">
                                <Form.Group controlId="seriesNameId">
                                    <Form.Label>Series Name</Form.Label>
                                    <input
                                        className="custom-input left-p-input"
                                        type="text"
                                        value={seriesInfo.SeriesName}
                                        disabled
                                        placeholder="Series Name"
                                        style={{ width: 220 }}
                                    />
                                </Form.Group>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Form> 
            <div style={{ paddingLeft: "10px", marginTop: "25px", }}>
                {rowData?.length > 0 && <>
                    <p className="ml-0 mb-0 fw-2" style={{ fontSize: "16px" }}>Series</p>
                    <div className="">
                        <button className="ISBNSubmit exprt-match ml-0" onClick={(e) => {
                            onExportClick();
                        }}>   <i className="fa fa-lg fa-download icon"></i>Export to Excel</button>
                        <button className="ISBNSubmit  exprt-match" disabled={selectedISBN.length < 1} onClick={selectISBNClick}> <i className="fa fa-lg fa-plus icon"></i>Add to Title List</button>
                    </div>
                    <div className="ag-theme-balham" style={{ marginBottom: "20px", height: heightSeriesGrid, overflow: "auto" }}>
                        <AgGridReact
                            rowData={rowData}
                            ref={gridRef}
                            columnDefs={columnDefs}
                           
                            gridOptions={gridOptions}
                            alwaysShowHorizontalScroll={true}
                            suppressHorizontalScroll={false}
                        />
                    </div></>}
                    {otherWorkData?.length > 0 &&    <><div className="">
                        <p className="ml-0 mb-0 fw-2" style={{ fontSize: "16px" }}>Other Works by Author</p>
                        <div className="">
                            <button className="ISBNSubmit exprt-match ml-0" onClick={(e) => {
                                onExportClick(otherGridRef);
                            }}>   <i className="fa fa-lg fa-download icon"></i>Export to Excel</button>
                            <button className="ISBNSubmit  exprt-match" disabled={selectedISBNAuth.length < 1} onClick={selectISBNClick}> <i className="fa fa-lg fa-plus icon"></i>Add to Title List</button>
                        </div>
                </div>
                    <div className="ag-theme-balham" style={{ marginBottom: "20px", overflow: "auto", height: heightAuthorGrid }}>
                        <AgGridReact
                            rowData={otherWorkData}
                                columnDefs={authorColumnDefs}
                            gridOptions={gridOptions}
                            ref={otherGridRef}
                            
                                onGridReady={onGridReady}
                            alwaysShowHorizontalScroll={true}
                            suppressHorizontalScroll={false}
                        />
                    </div></>}
                </div>
            
        </div>
    );
}
